/* upsb-nav3.js: navigation v3 (11 Oct 2026). Desktop panels and the phone menu loader.

   Desktop: every top item with children is a button that opens its panel on click, or on hover after 200 ms of
   intent (a click after that keeps it open). Opening one panel closes the open one at once, so two panels are never on
   screen together. Tab moves along
   the bar without entering a closed panel; Enter or Space opens it; Arrow Left/Right move along the bar; Arrow Down
   opens and moves into the panel; Escape closes and returns focus to the button.

   Phone: the drawer's menu is not in the page HTML. The first time the drawer opens, its content is fetched from the
   upsb-menu-drawer section (Section Rendering API) and replaces the plain fallback list. */
(function () {
  'use strict';

  var nav = document.querySelector('.upsb-n3');
  if (nav) {
    var tops = Array.prototype.slice.call(nav.querySelectorAll('.upsb-n3__top'));
    var buttons = tops.filter(function (t) { return t.tagName === 'BUTTON'; });
    var openBtn = null;
    var openedBy = null;   // 'hover', 'click' or 'key': how the open panel was opened
    var openTimer = null;
    var closeTimer = null;

    var panelOf = function (b) { return document.getElementById(b.getAttribute('aria-controls')); };

    var close = function (b) {
      var p = panelOf(b);
      if (p) p.hidden = true;
      b.setAttribute('aria-expanded', 'false');
      b.parentElement.classList.remove('is-open');
      if (openBtn === b) { openBtn = null; openedBy = null; }
    };

    var open = function (b, focusFirst, how) {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (openBtn && openBtn !== b) close(openBtn);
      var p = panelOf(b);
      if (!p) return;
      p.hidden = false;
      // never taller than the space left under the header (the header is sticky, so its bottom moves)
      p.style.maxHeight = Math.max(240, window.innerHeight - p.getBoundingClientRect().top - 8) + 'px';
      b.setAttribute('aria-expanded', 'true');
      b.parentElement.classList.add('is-open');
      openBtn = b;
      openedBy = how || 'click';
      if (focusFirst) {
        var f = p.querySelector('a[href], button, input');
        if (f) f.focus();
      }
    };

    buttons.forEach(function (b) {
      var li = b.parentElement;
      b.addEventListener('click', function () {
        clearTimeout(openTimer);
        if (b.getAttribute('aria-expanded') !== 'true') { open(b, false, 'click'); return; }
        // a click on a panel the mouse has just opened keeps it open (people hover, then click); the next click closes it
        if (openBtn === b && openedBy === 'hover') { openedBy = 'click'; return; }
        close(b);
      });
      li.addEventListener('pointerenter', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        clearTimeout(openTimer);
        if (openBtn) { open(b, false, 'hover'); return; }          // already browsing: switch at once
        openTimer = setTimeout(function () { open(b, false, 'hover'); }, 200);
      });
      li.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { if (openBtn === b) close(b); }, 300);
      });
    });

    // A plain top link (the Solutions Builder) closes an open panel when the mouse reaches it.
    tops.forEach(function (t) {
      if (t.tagName === 'BUTTON') return;
      t.parentElement.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse' && openBtn) { clearTimeout(openTimer); close(openBtn); }
      });
    });

    nav.addEventListener('keydown', function (e) {
      var i = tops.indexOf(document.activeElement);
      if (i > -1 && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        e.preventDefault();
        var n = tops[(i + (e.key === 'ArrowRight' ? 1 : -1) + tops.length) % tops.length];
        var wasOpen = !!openBtn;
        n.focus();
        if (wasOpen && n.tagName === 'BUTTON') open(n, false, 'key');
        else if (wasOpen && openBtn) close(openBtn);
      } else if (i > -1 && e.key === 'ArrowDown' && document.activeElement.tagName === 'BUTTON') {
        e.preventDefault();
        open(document.activeElement, true, 'key');
      } else if (e.key === 'Escape' && openBtn) {
        var b = openBtn;
        close(b);
        b.focus();
      }
    });

    nav.addEventListener('focusout', function (e) {
      if (openBtn && !nav.contains(e.relatedTarget)) close(openBtn);
    });

    document.addEventListener('click', function (e) {
      if (openBtn && !nav.contains(e.target)) close(openBtn);
    });

    // "N more series" toggles inside a brand block
    nav.addEventListener('click', function (e) {
      var m = e.target.closest('.upsb-n3__more');
      if (!m) return;
      var list = document.getElementById(m.getAttribute('aria-controls'));
      var expanded = m.getAttribute('aria-expanded') === 'true';
      if (list) {
        Array.prototype.forEach.call(list.querySelectorAll('.upsb-n3__extra'), function (li) { li.hidden = expanded; });
      }
      m.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      m.textContent = expanded ? m.dataset.more : m.dataset.less;
    });
  }

  // ---- Phone menu: fetch the drawer content on first open ----------------------------------------------------
  var body = document.querySelector('[data-upsb-n3d-body]');
  var container = document.getElementById('Details-menu-drawer-container');
  if (body && container) {
    var state = 'idle';
    var load = function () {
      if (state !== 'idle') return;
      state = 'loading';
      fetch(body.getAttribute('data-src'), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('[data-upsb-n3d-content]');
          if (!content) throw new Error('no drawer content');
          body.replaceChildren.apply(body, Array.prototype.slice.call(content.childNodes));
          body.classList.add('is-loaded');
          state = 'done';
        })
        .catch(function () { state = 'idle'; });   // the fallback list stays; the next open retries
    };
    container.addEventListener('toggle', function () { if (container.open) load(); });
    var summary = container.querySelector('summary');
    if (summary) {
      summary.addEventListener('pointerenter', load, { once: true });
      summary.addEventListener('touchstart', load, { once: true, passive: true });
    }
  }
})();
